document.addEventListener("DOMContentLoaded", function () {
  const html = document.documentElement;

  function getFormBlock() {
    return document.querySelector(".st-quote-form-sc .st-quote-form-block");
  }

  function openForm() {
    const formBlock = getFormBlock();
    if (!formBlock) return;
    formBlock.classList.add("active");
    html.classList.add("overflow-hidden");
  }

  function closeForm() {
    const formBlock = getFormBlock();
    if (formBlock) formBlock.classList.remove("active");
    html.classList.remove("overflow-hidden");
  }

  // Open on quote button (delegated: the button is re-rendered on every variant/option change)
  document.addEventListener("click", (e) => {
    if (e.target.closest(".quote-btn")) {
      e.preventDefault();
      openForm();
    }
  });

  // Close on close button
  document.addEventListener("click", (e) => {
    if (e.target.closest(".qoute-close-btn")) {
      e.preventDefault();
      closeForm();
    }
  });

  // Close on outside click
  document.addEventListener("click", (e) => {
    const formBlock = getFormBlock();
    if (
      formBlock &&
      formBlock.classList.contains("active") &&
      !formBlock.contains(e.target) &&
      !e.target.closest(".quote-btn")
    ) {
      closeForm();
    }
  });

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeForm();
    }
  });
});

// Shipping note js
document.addEventListener("click", function (event) {
  const toggleButton = event.target.closest(".st-cart-shipping-note-mobile-block");
  const clickedInsideNote = event.target.closest(".st-cart-shipping-note-mobile-text-block");
  const closeArrow = event.target.closest(".st-cart-shipping-note-mobile-close-arrow");

  // 1. If the user clicked the main toggle button, open/close the note
  if (toggleButton) {
    const textBlock = toggleButton.nextElementSibling;

    if (textBlock && textBlock.classList.contains("st-cart-shipping-note-mobile-text-block")) {
      textBlock.classList.toggle("active");
      toggleButton.classList.toggle("is-open");
    }
    return; // Stop here
  }

  // 2. If the user clicked inside the note, BUT they didn't click the close arrow, do nothing
  if (clickedInsideNote && !closeArrow) {
    return;
  }

  // 3. If the user clicked outside the note, OR they clicked the close arrow, close it!
  const activeNotes = document.querySelectorAll(".st-cart-shipping-note-mobile-text-block.active");

  activeNotes.forEach(function (note) {
    note.classList.remove("active");

    // Reset the open state on the main button too
    const relatedButton = note.previousElementSibling;
    if (relatedButton && relatedButton.classList.contains("st-cart-shipping-note-mobile-block")) {
      relatedButton.classList.remove("is-open");
    }
  });
});

// Shipping note — persistent dismissal
// The cart-drawer lead-time note (settings.cart_shipping_note) can be closed for
// the rest of the session. The flag lives in sessionStorage so it comes back on
// a new session. The cart drawer re-renders its section markup on every cart
// mutation, so re-apply on the theme's cart events as well as on load.
(function () {
  const STORAGE_KEY = "otto:cartShippingNoteDismissed";

  function isDismissed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function hideNote(note) {
    note.hidden = true;
    const openPanel = note.querySelector(".st-cart-shipping-note-mobile-text-block.active");
    if (openPanel) openPanel.classList.remove("active");
    const toggle = note.querySelector(".st-cart-shipping-note-mobile-block.is-open");
    if (toggle) toggle.classList.remove("is-open");
  }

  function applyDismissed() {
    if (!isDismissed()) return;
    document.querySelectorAll("[data-cart-shipping-note]").forEach(hideNote);
  }

  // Capture phase, so this runs before the mobile toggle handler above and can
  // stop the slide-up panel flashing open when the dismiss control is tapped.
  document.addEventListener(
    "click",
    function (event) {
      if (!event.target.closest("[data-cart-shipping-note-dismiss]")) return;
      const note = event.target.closest("[data-cart-shipping-note]");
      if (!note) return;
      event.preventDefault();
      event.stopPropagation();
      try {
        sessionStorage.setItem(STORAGE_KEY, "1");
      } catch (e) {}
      hideNote(note);
    },
    true,
  );

  document.addEventListener("DOMContentLoaded", applyDismissed);
  document.addEventListener("cart:change", applyDismissed);
  document.addEventListener("cart:refresh", applyDismissed);
  document.addEventListener("cart-drawer:refreshed", applyDismissed);
  applyDismissed();
})();

// Roomvo "See This In My Room" click tracking (independent of Roomvo's own analytics forwarding, which doesn't reach GA4 on this store)
document.addEventListener(
  "click",
  function (event) {
    const trigger = event.target.closest(".roomvo-stimr");
    if (!trigger) return;

    const measurementId = window.themeVariables?.settings?.ga4MeasurementId;
    if (!measurementId || typeof window.gtag !== "function") return;

    const pushRoomvoEvent = function () {
      if (!window.Shopify.customerPrivacy?.analyticsProcessingAllowed?.()) return;

      window.gtag("event", "roomvo_stimr_click", {
        event_category: "Roomvo",
        event_label: trigger.dataset.roomvoProductCode || "",
        product_type: trigger.dataset.productType || "",
        send_to: measurementId,
      });
    };

    if (window.Shopify?.customerPrivacy) {
      pushRoomvoEvent();
    } else {
      window.Shopify?.loadFeatures?.([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
        if (!error) pushRoomvoEvent();
      });
    }
  },
  true,
);
